import {
  AttributesView,
  Card,
  JsonLog,
  ScrollingTextArea,
  toAttributes,
} from "@bagel-web/components";
import { CommonAPIRequest } from "../types";

const APIRequestCards = ({ apiRequest }: { apiRequest: CommonAPIRequest }) => {
  return (
    <>
      <Card title="Request">
        <div className="mb-3">
          <AttributesView
            attributes={toAttributes(apiRequest.request.headers)}
            truncateValues={false}
          />
        </div>
        {apiRequest.request.body && (
          <JsonLog
            id={`request-${apiRequest.id}`}
            data={JSON.parse(apiRequest.request.body)}
          />
        )}
      </Card>
      <Card title="Response">
        {apiRequest.response ? (
          <>
            <div className="mb-3">
              <ScrollingTextArea>
                <AttributesView
                  attributes={toAttributes(apiRequest.response.headers)}
                  truncateValues={false}
                />
              </ScrollingTextArea>
            </div>
            {apiRequest.response.body && (
              <JsonLog
                id={`response-${apiRequest.id}`}
                data={JSON.parse(apiRequest.response.body)}
              />
            )}
          </>
        ) : (
          <div className="text-muted">No response recorded.</div>
        )}
      </Card>
    </>
  );
};

export default APIRequestCards;
